/* =========================================================
   SMASHA — Scripts globaux
   Menu mobile · Drawer panier (API Cart Shopify) · Reveal
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Utilitaires ---------- */
  var S = (window.SmashaTheme = window.SmashaTheme || {});
  var money = S.moneyFormat || '{{amount_with_comma_separator}} €';

  S.formatMoney = function (cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return money
      .replace('{{amount_with_comma_separator}}', int + ',' + parts[1])
      .replace('{{amount}}', int + '.' + parts[1])
      .replace('{{amount_no_decimals}}', int)
      .replace('{{amount_no_decimals_with_comma_separator}}', int);
  };

  S.t = function (key, fallback) {
    return (S.strings && S.strings[key]) || fallback || '';
  };

  /* ---------- Remise groupée dégressive ----------
     Les paliers viennent des réglages du thème (layout/theme.liquid) et doivent
     refléter les remises automatiques de Shopify. bundlePct rend le meilleur
     taux atteint, nextTier le prochain palier à décrocher. */
  S.bundlePct = function (qty) {
    var tiers = S.bundleTiers || [];
    var best = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min && tiers[i].pct > best) best = tiers[i].pct;
    }
    return best;
  };

  S.nextTier = function (qty) {
    var tiers = (S.bundleTiers || []).slice().sort(function (a, b) { return a.min - b.min; });
    for (var i = 0; i < tiers.length; i++) {
      if (qty < tiers[i].min) return tiers[i];
    }
    return null;
  };

  S.pctLabel = function (pct) { return Math.round(pct * 100); };

  function el(id) { return document.getElementById(id); }

  /* ---------- Menu mobile ---------- */
  (function mobileMenu() {
    var menu = el('mobMenu');
    var burger = document.querySelector('.burger');
    if (!menu || !burger) return;

    function open(isOpen) {
      menu.hidden = !isOpen;
      document.body.style.overflow = isOpen ? 'hidden' : '';
      burger.setAttribute('aria-expanded', isOpen);
    }

    burger.addEventListener('click', function () { open(true); });
    var close = el('mobClose');
    if (close) close.addEventListener('click', function () { open(false); });

    var subBtn = el('mobSubBtn');
    var subWrap = el('mobSubWrap');
    if (subBtn && subWrap) {
      subBtn.addEventListener('click', function () {
        var willOpen = subWrap.hidden;
        subWrap.hidden = !willOpen;
        subBtn.setAttribute('aria-expanded', willOpen);
        subBtn.classList.toggle('open', willOpen);
      });
    }

    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) open(false);
    });
  })();

  /* ---------- Drawer panier ---------- */
  (function cartDrawer() {
    var drawer = el('cartDrawer');
    var scrim = el('cartScrim');
    if (!drawer || !scrim) return;

    var SHIP_FREE = (S.freeShippingThreshold || 100) * 100; // en centimes

    function open(isOpen) {
      drawer.classList.toggle('open', isOpen);
      scrim.hidden = !isOpen;
      document.body.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen) {
        var c = el('cartClose');
        if (c) c.focus();
      }
    }
    S.openCart = open;

    /* Propriétés masquées de Shopify (préfixées par _) exclues de l'affichage */
    function visibleProps(props) {
      var out = [];
      for (var k in props) {
        if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
        if (k.charAt(0) === '_' || !props[k]) continue;
        out.push({ key: k, value: props[k] });
      }
      return out;
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function lineMeta(item) {
      var rows = [];
      if (item.options_with_values) {
        item.options_with_values.forEach(function (o) {
          if (o.value && o.value !== 'Default Title') {
            rows.push(escapeHtml(o.name) + ' : ' + escapeHtml(o.value));
          }
        });
      }
      visibleProps(item.properties || {}).forEach(function (p) {
        var v = p.value;
        /* Un fichier téléversé arrive sous forme d'URL : on n'affiche que le nom */
        if (typeof v === 'string' && v.indexOf('/uploads/') > -1) {
          v = decodeURIComponent(v.split('/').pop().split('?')[0]);
        }
        rows.push(escapeHtml(p.key) + ' : ' + escapeHtml(v));
      });
      return rows.join('<br>');
    }

    function render(cart) {
      var items = cart.items || [];
      var count = cart.item_count || 0;
      var pct = S.bundlePct(count);
      var badge = S.t('cart_offer_badge', '−{pct} %').replace('{pct}', S.pctLabel(pct));

      document.querySelectorAll('.cart-count').forEach(function (b) {
        b.textContent = count;
        b.style.display = count ? 'grid' : 'none';
      });

      var cartN = el('cartN');
      if (cartN) cartN.textContent = count ? '(' + count + ')' : '';
      var empty = el('cartEmpty');
      if (empty) empty.style.display = count ? 'none' : 'flex';
      var foot = el('cartFoot');
      if (foot) foot.hidden = !count;
      var shipEl = el('cartShip');
      if (shipEl) shipEl.hidden = !count;

      /* Lignes */
      var box = el('cartItems');
      if (box) {
        box.innerHTML = items.map(function (item) {
          var discounted = item.total_discount > 0;
          var isFree = item.final_line_price === 0;
          var img = item.image
            ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')
            : (S.placeholderImage || '');
          var price = isFree
            ? '<span class="free">' + S.t('cart_free', 'Offert') + '</span>'
            : S.formatMoney(item.final_line_price);
          var was = discounted && !isFree
            ? '<span class="old">' + S.formatMoney(item.original_line_price) + '</span>'
            : '';

          return '' +
            '<div class="cart-item" data-key="' + item.key + '">' +
              '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="72" height="72">' +
              '<div class="ci-info">' +
                '<span class="ci-name">' + escapeHtml(item.product_title) + '</span>' +
                '<div class="ci-meta">' + lineMeta(item) + '</div>' +
                (item.quantity > 1 ? '<div class="ci-meta">' + S.t('cart_qty', 'Quantité') + ' : ' + item.quantity + '</div>' : '') +
                (discounted ? '<span class="ci-free">' + escapeHtml(badge) + '</span>' : '') +
              '</div>' +
              '<div class="ci-side">' +
                '<span class="ci-price">' + was + price + '</span>' +
                '<button class="ci-remove" type="button" data-remove="' + item.key + '">' + S.t('cart_remove', 'Retirer') + '</button>' +
              '</div>' +
            '</div>';
        }).join('');
      }

      /* Message d'offre dégressive : soit la remise obtenue, soit le palier suivant */
      var offer = el('cartOffer');
      if (offer) {
        var next = S.nextTier(count);
        if (cart.total_discount > 0 && pct > 0) {
          offer.textContent = S.t('cart_offer_done', '−{pct} % appliqués — vous économisez {amount}')
            .replace('{pct}', S.pctLabel(pct))
            .replace('{amount}', S.formatMoney(cart.total_discount));
        } else if (count > 0 && next) {
          var missing = next.min - count;
          offer.textContent = S.t('cart_offer_progress', 'Plus que {n} maillot{s} pour −{pct} %')
            .replace('{n}', missing)
            .replace('{s}', missing > 1 ? 's' : '')
            .replace('{pct}', S.pctLabel(next.pct));
        } else {
          offer.textContent = '';
        }
      }

      /* Total */
      var label = el('cartTotalLabel');
      if (label) {
        label.textContent = S.t('cart_total', 'Total') +
          (count ? ' (' + count + ' ' + (count > 1 ? S.t('items', 'articles') : S.t('item', 'article')) + ')' : '');
      }
      var total = el('cartTotal');
      if (total) {
        total.innerHTML =
          (cart.total_discount > 0 ? '<span class="old">' + S.formatMoney(cart.original_total_price) + '</span>' : '') +
          S.formatMoney(cart.total_price);
      }

      /* Barre livraison offerte.
         Shopify échappe le HTML des traductions : on retire toute balise reçue
         et on met le montant en gras ici. */
      if (shipEl && count) {
        var remaining = SHIP_FREE - cart.total_price;
        var ratio = Math.min(100, Math.round((cart.total_price / SHIP_FREE) * 100));
        shipEl.classList.toggle('done', remaining <= 0);
        shipEl.innerHTML =
          (remaining > 0
            ? S.t('ship_progress', 'Plus que {amount} pour la livraison offerte')
                .replace(/&lt;\/?strong&gt;|<\/?strong>/g, '')
                .replace('{amount}', '<strong>' + S.formatMoney(remaining) + '</strong>')
            : S.t('ship_done', 'Livraison offerte débloquée !')) +
          '<div class="ship-bar"><div class="ship-fill" style="width:' + ratio + '%"></div></div>';
      }
    }
    S.renderCart = render;

    function fetchCart() {
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    S.refreshCart = function () { return fetchCart().then(render); };

    /* Ajout au panier — accepte un tableau de lignes {id, quantity, properties} */
    S.addToCart = function (lines) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Erreur panier');
          return fetchCart().then(function (cart) { render(cart); open(true); return cart; });
        });
    };

    /* Ajout via FormData (nécessaire pour le téléversement de fichiers) */
    S.addFormToCart = function (formData) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Erreur panier');
          return res.body;
        });
    };

    function changeLine(key, quantity) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(render);
    }

    /* Interactions */
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(true); });
    });
    var closeBtn = el('cartClose');
    if (closeBtn) closeBtn.addEventListener('click', function () { open(false); });
    var cont = el('cartContinue');
    if (cont) cont.addEventListener('click', function () { open(false); });
    scrim.addEventListener('click', function () { open(false); });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) open(false);
    });

    var itemsBox = el('cartItems');
    if (itemsBox) {
      itemsBox.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove]');
        if (!btn) return;
        btn.disabled = true;
        changeLine(btn.dataset.remove, 0);
      });
    }

    var checkout = el('cartCheckout');
    if (checkout) {
      checkout.addEventListener('click', function () {
        checkout.textContent = S.t('cart_redirect', 'Redirection vers le paiement…');
        checkout.disabled = true;
        window.location.href = window.Shopify.routes.root + 'checkout';
      });
    }

    /* État initial injecté par Liquid, puis rafraîchi */
    if (S.initialCart) render(S.initialCart);
  })();

  /* ---------- Reveal au scroll ---------- */
  (function reveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('on');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  })();
})();
